const key = '_za_param'

const storage = {
    init() {
        let json = localStorage.getItem(key)
        if (!json) {
            json = ''
        }
        let no = ''
        let uid = ''
        let channel = ''
        let guard = ''
        let businessInfo = ''
        if (json != '') {
            json = JSON.parse(json)
            if (json.hasOwnProperty('_ApplyOrderNo')) {
                no = json._ApplyOrderNo
            }
            if (json.hasOwnProperty('_UID')) {
                uid = json._UID
            }
            if (json.hasOwnProperty('_channel')) {
                channel = json._channel
            }
            if (json.hasOwnProperty('guard')) {
                guard = json.guard
            }
            if (json.hasOwnProperty('_BusinessInfo')) {
                businessInfo = json._BusinessInfo
            }
        }
        let init = {
            token: '',
            _Apply: '0',
            _ApplyStatus: '0',
            _CreditCardInfo: '0',
            _ApplyOrderNo: no,
            _UID: uid,
            _channel: channel,
            _BusinessInfo: businessInfo,
            guard: guard
        }
        init = JSON.stringify(init)
        localStorage.setItem(key, init)
    },
    status() {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            return false
        }
        json = JSON.parse(json)
        if (json.token == '') {
            return false
        } else {
            return true
        }
    },
    set(data) {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            json = '{}'
        }
        json = JSON.parse(json)
        json = Object.assign({}, json, data)
        json = JSON.stringify(json)
        localStorage.setItem(key, json)
    },
    get(name) {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            return ''
        }
        json = JSON.parse(json)
        if (json[name] != '0' && (!json[name] || json[name] == '')) {
            return ''
        }
        return json[name]
    },
    remove(name) {
        let json = localStorage.getItem(key)
        if (!json || json == '') {
            return ''
        }
        json = JSON.parse(json)
        delete json[name];
        json = JSON.stringify(json)
        localStorage.setItem(key, json)
    }
}

export default storage



// WEBPACK FOOTER //
// ./src/utils/storage.js